"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_community(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "community-hi"), /*#__PURE__*/React.createElement("g", {
    id: "85bd5deb-dbf2-4dc7-b346-ece2bb91a99e",
    "data-name": "community-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a30fc02-f08e-4024-bb0d-49bca757da4b",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bf361e87-d7b8-42a3-9602-d82b54d299e1",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fc488f9f-9069-406a-a94a-1a836aaaf05d",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c5e38671-4e13-4f87-9ecc-df214e7db8e2",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c7b2716f-f5d6-4803-baf7-f526d5152181",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7da31e1c-f031-4b0b-b398-f1f336afb586",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e31ee034-a644-4166-aaa6-efc050483a77",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b907e4b3-c8f8-4706-9fd8-54b0706edb95",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a77e4a9c-e097-46ef-8554-71d03cbcee69",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dbf6febe-f9e2-4a48-9a78-83cb5a849aa5",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96.12,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.12a80,80,0,0,1-80-79c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174.12Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,74.55a48.09,48.09,0,0,0-37-25.56",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.38,49a48.08,48.08,0,0,0-36.13,23.9",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,144.62A48.09,48.09,0,0,1,57.47,125",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.93,115.25a48.08,48.08,0,0,1,3-43.22",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,144.62A48.09,48.09,0,0,0,134.67,125",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,115.25a48.08,48.08,0,0,0-3-43.22",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.9,
    cy: 73.56,
    r: 18.23,
    fill: "#ebebeb",
    stroke: "#e60000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.1,
    cy: 73.56,
    r: 18.23,
    fill: "#ebebeb",
    stroke: "#e60000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 144.96,
    r: 18.23,
    fill: "#ebebeb",
    stroke: "#e60000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })))))))))))));
}

var _default = ic_community;
exports.default = _default;